import { render, staticRenderFns } from "./CouponCard.vue?vue&type=template&id=9ac2918a&scoped=true"
import script from "./CouponCard.vue?vue&type=script&lang=js"
export * from "./CouponCard.vue?vue&type=script&lang=js"
import style0 from "./CouponCard.vue?vue&type=style&index=0&id=9ac2918a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ac2918a",
  null
  
)

export default component.exports